import EditorAnglesReducer from "./reducer";
import * as types from "./types";

import {useEditorAnglesDispatch, useEditorAnglesState} from "./context";

const useEditorAngles = ({ reducer = EditorAnglesReducer } = {}) => {
    const dispatch = useEditorAnglesDispatch();
    const { angles, selectedAngles, dropdownAngles, anglesInitialised, anglesAudio, audioPlayerReady } = useEditorAnglesState();

    const setAngles = (angles: types.FixtureFiles[]) => {
        dispatch({ type: types.SET_EDITOR_ANGLES, angles });
    };

    const setSelectedAngles = (selectedAngles: types.Angle[]) => {
        dispatch({ type: types.SET_EDITOR_SELECTED_ANGLES, selectedAngles });
    };

    const setDropdownAngles = (dropdownAngles: types.FixtureFiles[]) => {
        dispatch({ type: types.SET_EDITOR_DROPDOWN_ANGLES, dropdownAngles });
    };

    const setAnglesInitialised = (anglesInitialised: boolean) => {
        dispatch({ type: types.SET_EDITOR_INITIALISED_ANGLES, anglesInitialised });
    }

    const setAnglesAudio = (
        anglesAudioOrUpdater: types.AngleAudio[] | ((prev: types.AngleAudio[]) => types.AngleAudio[])
    ) => {
        dispatch({ type: types.SET_EDITOR_ANGLES_AUDIO, anglesAudio: anglesAudioOrUpdater });
    }

    const setAudioPlayerReady = (audioPlayerReady: boolean) => {
        dispatch({ type: types.SET_EDITOR_AUDIO_PLAYER_READY, audioPlayerReady });
    }

    const resetEditorAnglesState = () => {
        dispatch({ type: types.SET_EDITOR_ANGLES, angles: [] });
        dispatch({ type: types.SET_EDITOR_SELECTED_ANGLES, selectedAngles: [] });
        dispatch({ type: types.SET_EDITOR_DROPDOWN_ANGLES, dropdownAngles: [] });
        dispatch({ type: types.SET_EDITOR_INITIALISED_ANGLES, anglesInitialised: false });
        dispatch({ type: types.SET_EDITOR_ANGLES_AUDIO, anglesAudio: [] });
        dispatch({ type: types.SET_EDITOR_AUDIO_PLAYER_READY, audioPlayerReady: false});
    }

    return {
        angles,
        selectedAngles,
        dropdownAngles,
        anglesInitialised,
        anglesAudio,
        audioPlayerReady,
        setAngles,
        setSelectedAngles,
        setDropdownAngles,
        setAnglesInitialised,
        setAnglesAudio,
        resetEditorAnglesState,
        setAudioPlayerReady
    };
}


export default useEditorAngles;